import { render, staticRenderFns } from "./ManufacturerFilteredSearch.vue?vue&type=template&id=065ad452"
import script from "./ManufacturerFilteredSearch.vue?vue&type=script&lang=js"
export * from "./ManufacturerFilteredSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports